import React, { useState } from 'react';
import './Profile.css';

export default function Profile({ user, onLogout }) {
  const [activeTab, setActiveTab] = useState('account');
  const [finnhubKey, setFinnhubKey] = useState('');
  const [keyStatus, setKeyStatus] = useState(null);
  const [notifications, setNotifications] = useState({ news:true, halts:true, scanner:true, pdt:true });
  const [theme, setTheme] = useState('dark');
  const [defaultLayout, setDefaultLayout] = useState('2x2');
  const [saved, setSaved] = useState(false);

  const displayName = user?.name || 'Trader';
  const displayEmail = user?.email || 'trader@thegroovetrading.com';
  const initials = displayName.charAt(0).toUpperCase();

  function saveKey() {
    if(!finnhubKey) return;
    setKeyStatus('saving');
    setTimeout(() => setKeyStatus('saved'), 1200);
  }

  function saveSettings() {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  function toggleNotif(key) {
    setNotifications(prev => ({...prev, [key]: !prev[key]}));
  }

  const TABS = [
    { id:'account',       label:'Account' },
    { id:'api',           label:'API Keys' },
    { id:'notifications', label:'Notifications' },
    { id:'appearance',    label:'Appearance' },
    { id:'subscription',  label:'Subscription' },
  ];

  return (
    <div className="pf-page">
      <div className="pf-inner">
        {/* SIDEBAR */}
        <div className="pf-sidebar">
          <div className="pf-avatar-wrap">
            <div className="pf-avatar">{initials}</div>
            <div className="pf-user-name">{displayName}</div>
            <div className="pf-user-email">{displayEmail}</div>
            <div className="pf-plan-pill">Free Plan</div>
          </div>
          <div className="pf-nav">
            {TABS.map(t=>(
              <div key={t.id} className={`pf-nav-item ${activeTab===t.id?'active':''}`} onClick={()=>setActiveTab(t.id)}>
                {t.label}
              </div>
            ))}
          </div>
          <button className="pf-logout" onClick={onLogout}>Sign Out</button>
        </div>

        {/* CONTENT */}
        <div className="pf-content">

          {/* ACCOUNT TAB */}
          {activeTab === 'account' && (
            <div className="pf-tab-content">
              <div className="pf-tab-title">Account Settings</div>
              <div className="pf-card">
                <div className="pf-card-title">Profile Information</div>
                <div className="pf-fields">
                  <div className="pf-field"><label>Full Name</label><input defaultValue={displayName} /></div>
                  <div className="pf-field"><label>Email Address</label><input defaultValue={displayEmail} /></div>
                  <div className="pf-field"><label>Username</label><input defaultValue={displayName.toLowerCase().replace(' ','_')} /></div>
                  <div className="pf-field"><label>Trading Experience</label>
                    <select>
                      <option>Beginner (Less than 1 year)</option>
                      <option>Intermediate (1-3 years)</option>
                      <option>Advanced (3-5 years)</option>
                      <option>Expert (5+ years)</option>
                    </select>
                  </div>
                </div>
                <button className="pf-save-btn" onClick={saveSettings}>{saved?'✓ Saved!':'Save Changes'}</button>
              </div>
              <div className="pf-card">
                <div className="pf-card-title">Change Password</div>
                <div className="pf-fields">
                  <div className="pf-field"><label>Current Password</label><input type="password" placeholder="••••••••" /></div>
                  <div className="pf-field"><label>New Password</label><input type="password" placeholder="••••••••" /></div>
                  <div className="pf-field"><label>Confirm New Password</label><input type="password" placeholder="••••••••" /></div>
                </div>
                <button className="pf-save-btn" onClick={saveSettings}>Update Password</button>
              </div>
              <div className="pf-card danger">
                <div className="pf-card-title" style={{color:'#ef4444'}}>Danger Zone</div>
                <div style={{fontSize:12,color:'#484f58',marginBottom:12}}>Once you delete your account all your trade journal data will be permanently removed.</div>
                <button className="pf-danger-btn">Delete Account</button>
              </div>
            </div>
          )}

          {/* API KEYS TAB */}
          {activeTab === 'api' && (
            <div className="pf-tab-content">
              <div className="pf-tab-title">API Keys</div>
              <div className="pf-card">
                <div className="pf-card-title">Finnhub API Key</div>
                <div style={{fontSize:12,color:'#484f58',marginBottom:14,lineHeight:1.6}}>
                  Connect your free Finnhub API key to enable real-time live market data across all charts and news feeds.
                  Get your free key at <a href="https://finnhub.io/register" target="_blank" rel="noreferrer" style={{color:'#2563eb'}}>finnhub.io</a>
                </div>
                <div className="pf-api-row">
                  <input
                    className="pf-api-input"
                    placeholder="Paste your Finnhub API key here..."
                    value={finnhubKey}
                    onChange={e=>setFinnhubKey(e.target.value)}
                    type="password"
                  />
                  <button className="pf-save-btn" style={{margin:0,width:'auto',padding:'8px 16px'}} onClick={saveKey}>
                    {keyStatus==='saving'?'Connecting...':keyStatus==='saved'?'✓ Connected!':'Connect'}
                  </button>
                </div>
                {keyStatus==='saved' && (
                  <div className="pf-success-msg">✓ Finnhub connected — your charts now show real live data!</div>
                )}
              </div>
              <div className="pf-card">
                <div className="pf-card-title">Alpaca Paper Trading API</div>
                <div style={{fontSize:12,color:'#484f58',marginBottom:14,lineHeight:1.6}}>
                  Coming soon — connect Alpaca to enable real paper trading execution with live order fills.
                </div>
                <div className="pf-coming-soon-pill">Coming Soon</div>
              </div>
              <div className="pf-card">
                <div className="pf-card-title">Broker API Connections</div>
                <div style={{fontSize:12,color:'#484f58',marginBottom:14,lineHeight:1.6}}>
                  Direct broker integrations for thinkorswim, Webull, and Interactive Brokers coming in Pro tier.
                </div>
                <div className="pf-coming-soon-pill">Pro Feature — Coming Soon</div>
              </div>
            </div>
          )}

          {/* NOTIFICATIONS TAB */}
          {activeTab === 'notifications' && (
            <div className="pf-tab-content">
              <div className="pf-tab-title">Notification Settings</div>
              <div className="pf-card">
                <div className="pf-card-title">Alert Preferences</div>
                {[
                  { key:'news',    label:'Breaking News Alerts',    desc:'Get notified when urgent market news hits your watchlist symbols' },
                  { key:'halts',   label:'Trading Halt Alerts',     desc:'Immediate notification when a stock on your watchlist gets halted' },
                  { key:'scanner', label:'Scanner Momentum Alerts', desc:'Get alerted when a stock crosses your RS score threshold' },
                  { key:'pdt',     label:'PDT Rule Updates',        desc:'Stay informed about Pattern Day Trader rule changes and announcements' },
                ].map(n=>(
                  <div key={n.key} className="pf-notif-row">
                    <div className="pf-notif-info">
                      <div className="pf-notif-label">{n.label}</div>
                      <div className="pf-notif-desc">{n.desc}</div>
                    </div>
                    <button
                      className={`pf-toggle ${notifications[n.key]?'on':'off'}`}
                      onClick={()=>toggleNotif(n.key)}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* APPEARANCE TAB */}
          {activeTab === 'appearance' && (
            <div className="pf-tab-content">
              <div className="pf-tab-title">Appearance</div>
              <div className="pf-card">
                <div className="pf-card-title">Theme</div>
                <div className="pf-theme-options">
                  {['dark','darker','midnight'].map(t=>(
                    <div key={t} className={`pf-theme-opt ${theme===t?'active':''}`} onClick={()=>setTheme(t)}>
                      <div className="pf-theme-preview" style={{background:t==='dark'?'#0d1117':t==='darker'?'#080b10':'#060912'}}></div>
                      <div className="pf-theme-label">{t.charAt(0).toUpperCase()+t.slice(1)}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="pf-card">
                <div className="pf-card-title">Default Chart Layout</div>
                <div className="pf-layout-options">
                  {['1x2','2x2','3x2'].map(l=>(
                    <button key={l} className={`pf-layout-btn ${defaultLayout===l?'active':''}`} onClick={()=>setDefaultLayout(l)}>{l}</button>
                  ))}
                </div>
              </div>
              <div className="pf-card">
                <div className="pf-card-title">Default Indicators</div>
                <div style={{fontSize:12,color:'#484f58',marginBottom:12}}>Choose which indicators appear on new charts by default.</div>
                {['VWAP','EMA 9','EMA 20','EMA 200','Bollinger Bands','Volume'].map(ind=>(
                  <div key={ind} className="pf-notif-row">
                    <div className="pf-notif-label">{ind}</div>
                    <button className={`pf-toggle ${['VWAP','EMA 9','EMA 20'].includes(ind)?'on':'off'}`} />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* SUBSCRIPTION TAB */}
          {activeTab === 'subscription' && (
            <div className="pf-tab-content">
              <div className="pf-tab-title">Subscription</div>
              <div className="pf-card">
                <div className="pf-card-title">Current Plan</div>
                <div className="pf-current-plan">
                  <div className="pf-cp-name">Free Plan</div>
                  <div className="pf-cp-price">$0 / month</div>
                  <div className="pf-cp-features">
                    {['1 chart panel','Paper trading — all brokers','Basic trade journal','Demo market data'].map(f=>(
                      <div key={f} className="pf-cp-feature"><span style={{color:'#22c55e'}}>✓</span> {f}</div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="pf-card highlight">
                <div className="pf-plan-badge">Upgrade to Pro</div>
                <div className="pf-card-title">Pro Plan — $29/month</div>
                <div className="pf-cp-features">
                  {['Unlimited chart panels','All chart types & indicators','Full trade journal + CSV import','TRUE live market data via Finnhub','Advanced momentum scanner','Live news feed with alerts'].map(f=>(
                    <div key={f} className="pf-cp-feature"><span style={{color:'#22c55e'}}>✓</span> {f}</div>
                  ))}
                </div>
                <button className="pf-upgrade-btn">Upgrade to Pro →</button>
              </div>
              <div className="pf-card">
                <div className="pf-card-title">Family Plan — $49/month</div>
                <div style={{fontSize:12,color:'#484f58',marginBottom:12}}>Everything in Pro for up to 3 users. Perfect for trading with family members.</div>
                <button className="pf-save-btn">Get Family Plan →</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}